// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"3c0319c9f34614ac","6690":"c9d809fe7733927d","8059":"6dba793cbcafa29b"}[chunkId] + ".css";
};